import { createApiService, API_CONFIGS } from '../utils/apiService';
import axios from "@configs/axios";
import AxiosModule from "axios";

const operations = {
  createMarketBuy: createApiService(
    (trade_types, pair_type, pair_amount, request_type, irrWallet, usdtWallet, lang, amountType, reservePayment = false, market_price) => {
      console.log(
        "Market Buy =>",
        "pairType:", pair_type,
        "pairAmount:", pair_amount,
        "irWallet:", irrWallet,
        "usdtWallet:", usdtWallet,
        "lang:", lang,
        "amountType:", amountType,
        "trade_type:", trade_types,
        "market_price:", market_price
      );

      const data = {
        pair_type,
        pair_amount,
        request_type,
        irr_wallet: irrWallet,
        usdt_wallet: usdtWallet,
        amount_type: amountType,
        reserve_payment: reservePayment,
        trade_type: trade_types,
        market_price,
      };

      return axios.post("/trade/marketBuy", data, {
        headers: { "x-lang": `${lang}` }
      });
    },
    { ...API_CONFIGS.POST_ACTION, context: 'Trade - Market Buy' }
  ),
  createMarketSell: createApiService(
    (trade_types, pair_type, pair_amount, request_type, receipt_type, lang, amount_type, market_price) => {
      console.log(
        "Market Sell =>",
        "pairType:", pair_type,
        "pairAmount:", pair_amount,
        "request type:", request_type,
        "receipt type :", receipt_type,
        "amount_type", amount_type,
        "market_price:", market_price
      );

      const data = {
        pair_type,
        pair_amount,
        request_type,
        receipt_type,
        amount_type,
        trade_type: trade_types,
        market_price,
      };

      return axios.post("/trade/marketSell", data, {
        headers: { "x-lang": `${lang}` }
      });
    },
    { ...API_CONFIGS.POST_ACTION, context: 'Trade - Market Sell' }
  ),
  createLimitBuy: createApiService(
    (pair_type, pair_price, pair_amount, request_type, lang, amount_type) => {
      console.log(
        "Limit Buy =>",
        "pairType:", pair_type,
        "pairAmount:", pair_amount,
        "pairPrice:", pair_price,
        "requestType:", request_type,
        "lang:", lang,
        "amountType:", amount_type
      );

      const data = {
        pair_type,
        pair_price,
        pair_amount,
        request_type,
        amount_type,
        irr_wallet: amount_type === "toman",
        usdt_wallet: amount_type === "usdt",
      };

      return axios.post("/trade/limitBuy", data, {
        headers: { "x-lang": `${lang}` }
      });
    },
    { ...API_CONFIGS.POST_ACTION, context: 'Trade - Limit Buy' }
  ),
  createLimitSell: createApiService(
    (pair_type, pair_price, pair_amount, request_type, lang, amount_type, receipt_type) => {
      console.log(
        "Limit Sell =>",
        "pairType:", pair_type,
        "pairAmount:", pair_amount,
        "pairPrice:", pair_price,
        "requestType:", request_type,
        "lang:", lang,
        "amountType:", amount_type,
        "receipt_type", receipt_type
      );

      const data = {
        pair_type,
        pair_price,
        pair_amount,
        request_type,
        amount_type,
        receipt_type,
        irr_wallet: amount_type === "toman",
        usdt_wallet: amount_type === "usdt",
      };

      return axios.post("/trade/limitSell", data, {
        headers: { "x-lang": `${lang}` }
      });
    },
    { ...API_CONFIGS.POST_ACTION, context: 'Trade - Limit Sell' }
  ),
  getUsdtPrice: createApiService(
    () => axios.get("/tether_price/get"),
    {
      ...API_CONFIGS.GET_WITH_DATA,
      context: 'Trade - USDT Price',
      transformResponse: (data) => {
        if (data?.data?.tether_price) {
          return { USDTIRT: data.data.tether_price };
        }
        throw new Error('Invalid USDT price data structure');
      }
    }
  ),
};

export default operations;
